export default __webpack_public_path__ + "static/media/BigFlare.15668d17.png";